function fetchFromStorage (storage, key, defaultValue) {
    let fetchedValue = storage.getItem(key)
    defaultValue = defaultValue ?? null
    try {
        return JSON.parse(fetchedValue) ?? defaultValue
    } catch (e) {
        console.error(`Error parsing ${key} from ${storage}. Returning default value: ${defaultValue}`, e)
        return defaultValue
    }
}

export function fetchFromLocalStorage (key, defaultValue) {
    return fetchFromStorage(window.localStorage, key, defaultValue)
}

export function fetchFromSessionStorage (key, defaultValue) {
    return fetchFromStorage(window.sessionStorage, key, defaultValue)
}

function setInStorage (storage, key, value) {
    storage.setItem(key, JSON.stringify(value))
}

export function setInLocalStorage (key, value) {
    setInStorage(window.localStorage, key, value)
}

export function setInSessionStorage (key, value) {
    setInStorage(window.sessionStorage, key, value)
}
